module.exports = __webpack_public_path__ + "img/seven3Green.31b81fa9.jpg";